module.exports = __webpack_public_path__ + "img/sleeve opening.caa54082.png";